const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: "base" })

export function compareByCode(a, b) {
    return collator.compare(a?.code ?? "", b?.code ?? "")
}
